<template>
  <modal
    name="add-roles-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Add Roles</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group modified-toggle-switch">
            <div class="form-group mt-3">
              <label for="InputText" class="quantity">Role Name</label>
              <input
                type="text"
                class="textInputField"
                placeholder="Enter role name(s)"
                v-model="role_name"
              />
            </div>
          </div>
          <div class="">
            <p class="txt--xs txt--off-white">Permissions</p>
          </div>
         
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">
                <app-toggle
                  :checked="access_permissions.all_property_access"
                  :label="'All Properties'"
                  @update:checked="getCheckedPermissions($event, 'all_property_access')"

                >
                </app-toggle>
                <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.all_property_access">
                    <input type="checkbox" v-model="access_permissions.all_property_access_read"  value="1" class="cursor-pointer" checked disabled /> Read
                    <input type="checkbox" v-model="access_permissions.all_property_access_write"  value="1" class="cursor-pointer ml-3"/> Write
                </span>
              </div>
            </div>
          </div>
              
          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center"> 
                <app-toggle :checked="access_permissions.report_access" :label="'Reports'"
                  @update:checked="getCheckedPermissions($event, 'report_access')"
                
                >
                </app-toggle>
                <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.report_access">
                    <input type="checkbox" v-model="access_permissions.report_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                    <input type="checkbox" v-model="access_permissions.report_access_write" value="1" class="cursor-pointer ml-3"/> Write
                </span>
              </div>                  
            </div> 
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">               
                  <app-toggle
                    :checked="access_permissions.gate_access"
                    :label="'Gates'"
                    @update:checked="getCheckedPermissions($event, 'gate_access')"  
                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.gate_access">
                      <input type="checkbox"  v-model="access_permissions.gate_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox"  v-model="access_permissions.gate_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>                     
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">               
                  <app-toggle
                    :checked="access_permissions.session_access"
                    :label="'Sessions'"
                    @update:checked="getCheckedPermissions($event, 'session_access')"  
                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.session_access">
                      <input type="checkbox"  v-model="access_permissions.session_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox"  v-model="access_permissions.session_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>                     
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">               
                  <app-toggle
                    :checked="access_permissions.validation_access"
                    :label="'Validations'"
                    @update:checked="getCheckedPermissions($event, 'validation_access')"

                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.validation_access">
                      <input type="checkbox"  v-model="access_permissions.validation_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox"  v-model="access_permissions.validation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>                     
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">               
                  <app-toggle
                    :checked="access_permissions.permit_access"
                    :label="'Permits'"
                    @update:checked="getCheckedPermissions($event, 'permit_access')"

                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.permit_access">
                      <input type="checkbox"  v-model="access_permissions.permit_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox"  v-model="access_permissions.permit_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>                     
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-md-12">
              <div class="form-group d-flex align-items-center">               
                  <app-toggle
                    :checked="access_permissions.invitation_access"
                    :label="'Invitations'"
                    @update:checked="getCheckedPermissions($event, 'invitation_access')"

                  >
                  </app-toggle>
                  <span class="text-white txt--ss opacity--50 ml-5" v-if="access_permissions.invitation_access">
                      <input type="checkbox"  v-model="access_permissions.invitation_access_read" value="1" class="cursor-pointer" checked disabled /> Read
                      <input type="checkbox"  v-model="access_permissions.invitation_access_write" value="1" class="cursor-pointer ml-3"/> Write
                  </span>                     
              </div>
            </div>
          </div>
             
        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner class="button button--primary button--sm mr-3" @click="storeRole"
        :disabled="create_button.disabled"
        :loading="create_button.loading"
        :success="create_button.success"
        >
          Save</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
// import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import Toggle from "@/components/toggle";
export default {
  name: "AddRoles",
  components: {
    AppToggle: Toggle,
    // ModelListSelect,
    // ModelSelect,
    ButtonWithSpinner,
  },
  data() {
    return {
      role_name:'',
      access_permissions:{
        all_property_access:false,       
        property_access_list:[],
        report_access: false, 
        gate_access: false,
        //audit_access: false,
        permit_access : false,
        permit_access_list: [],
        session_access: false,
        invitation_access : false,
        validation_access : false,
      
        all_property_access_read:   true,
        all_property_access_write:  false,
        report_access_read:         true,
        report_access_write:        false,
        gate_access_read:           true,
        gate_access_write:          false,
        permit_access_read:         true,
        permit_access_write:        false,
        session_access_read:        true,
        session_access_write:       false,
        invitation_access_read:     true,
        invitation_access_write:    false,
        validation_access_read:     true,
        validation_access_write:    false,
      },
      status:1,
      property_list: [],
      create_button: {
        disabled: false,
        loading: false,
        success: false,
      },
    };
  },

  created() {},
  methods: {
    getCheckedPermissions(checked,type){
      if(type == 'all_property_access'){
        this.access_permissions.all_property_access = checked;
      }
      if(type == 'report_access'){
        this.access_permissions.report_access = checked;
      }
      if(type == 'gate_access'){
        this.access_permissions.gate_access=checked;
      }
      if(type == 'session_access'){
        this.access_permissions.session_access=checked;
      }
      if(type == 'validation_access'){
        this.access_permissions.validation_access=checked;
      }
      if(type == 'invitation_access'){
        this.access_permissions.invitation_access=checked;
      }
      if(type == 'permit_access'){
        this.access_permissions.permit_access=checked;
      }
    },
    closeModal() {
      this.reset();
      this.$modal.hide("add-roles-modal");
    },
    storeRole(){
      let owner_id = localStorage.getItem('user_id');
      if(this.role_name == ''){
          this.$toasted.show('Role name is required',{
              icon : 'times-circle',
              className: 'error-class'
          });    
          return false;       
      }

     if(this.access_permissions.all_property_access==false){
        this.access_permissions.all_property_access_read=false;
        this.access_permissions.all_property_access_write=false;
      }

      if(this.access_permissions.report_access==false){
        this.access_permissions.report_access_read=false;
        this.access_permissions.report_access_write=false;
      }

      if(this.access_permissions.gate_access==false){
        this.access_permissions.gate_access_read=false;
        this.access_permissions.gate_access_write=false;
      }

      if(this.access_permissions.session_access==false){
        this.access_permissions.session_access_read=false;
        this.access_permissions.session_access_write=false;
      }

      if(this.access_permissions.validation_access==false){
        this.access_permissions.validation_access_read=false;
        this.access_permissions.validation_access_write=false;
      }

      if(this.access_permissions.invitation_access==false){
        this.access_permissions.invitation_access_read=false;
        this.access_permissions.invitation_access_write=false;
      }

      if(this.access_permissions.permit_access==false){
        this.access_permissions.permit_access_read=false;
        this.access_permissions.permit_access_write=false;
      }

      this.create_button.loading = true;
      this.create_button.disabled = true;
      this.create_button.success = false;
      this.axios
        .post(window.hostname + "/api/auth/role/store", {
          role:this.role_name,
          //accesss
          all_property_access:this.access_permissions.all_property_access,
          report_access:this.access_permissions.report_access,
          gate_access:this.access_permissions.gate_access,
          session_access:this.access_permissions.session_access,
          validation_access:this.access_permissions.validation_access,
          invitation_access:this.access_permissions.invitation_access,
          permit_access:this.access_permissions.permit_access,
          permit_access_list: this.access_permissions.permit_access_list,
          //read write
          all_property_access_read:this.access_permissions.all_property_access_read,
          all_property_access_write:this.access_permissions.all_property_access_write,
          report_access_read:this.access_permissions.report_access_read,
          report_access_write:this.access_permissions.report_access_write,
          gate_access_read:this.access_permissions.gate_access_read,
          gate_access_write:this.access_permissions.gate_access_write,
          permit_access_read:this.access_permissions.permit_access_read,
          permit_access_write:this.access_permissions.permit_access_write,
          session_access_read:this.access_permissions.session_access_read,
          session_access_write:this.access_permissions.session_access_write,
          invitation_access_read:this.access_permissions.invitation_access_read,
          invitation_access_write:this.access_permissions.invitation_access_write,
          validation_access_read:this.access_permissions.validation_access_read,
          validation_access_write:this.access_permissions.validation_access_write,

          status:this.status,
          owner_id:owner_id
        }).then((res)=>{
          if(res.data.status){
            this.$toasted.show(res.data.message, {
                icon: "check-circle",
                className: "success-class",
            });
            this.$emit("update_role");

            this.create_button.disabled = false;
            this.create_button.success = true;
            this.create_button.loading = false;
            this.reset();
            this.closeModal();
            this.$emit("update_role");
          }
          else{
            this.create_button.disabled = false;
            this.create_button.success = false;
            this.create_button.loading = false;
            this.$toasted.show(res.data.message,{
                icon : 'times-circle',
                className: 'error-class'
            });            
          }
        })
        

    },
    reset() {
        this.role_name='',
        this.access_permissions.all_property_access =false;
        this.access_permissions.property_access_list =[];
        this.access_permissions.report_access =false;
        this.access_permissions.gate_access =false;
        this.access_permissions.permit_access =false;
        this.access_permissions.permit_access_list = [];
        this.access_permissions.session_access =false;
        this.access_permissions.invitation_access =false;
        this.access_permissions.validation_access =false;

        this.access_permissions.all_property_access_read =true;
        this.access_permissions.all_property_access_write =false;
        this.access_permissions.report_access_read =true;
        this.access_permissions.report_access_write =false;
        this.access_permissions.gate_access_read =true;
        this.access_permissions.gate_access_write =false;
        this.access_permissions.permit_access_read =true;
        this.access_permissions.permit_access_write =false;
        this.access_permissions.session_access_read =true;
        this.access_permissions.session_access_write =false;
        this.access_permissions.invitation_access_read =true;
        this.access_permissions.invitation_access_write =false;
        this.access_permissions.validation_access_read =true;
        this.access_permissions.validation_access_write =false;

        this.create_button.disabled =false;
        this.create_button.loading  =false;
        this.create_button.success =false;
    },
  },
};
</script>

<style scoped>
.modified-toggle-switch p {
  flex-basis: 50%;
}

.modified-toggle-switch app-toggle {
  flex-basis: 50%;
}
input[type="text"] {
  background: transparent;
  outline: none;
  border-radius: 22px;
  border: 1px solid #535353;
}
.quantity {
  color: #848484;
  font-size: 10px;
}
</style>